"use strict";
exports.__esModule = true;
var dimensionArrayEquals = function (a, b) {
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) {
        return false;
    }
    for (var i = 0; i < a.length; i++) {
        if (a[i].breakdown.value !== b[i].breakdown.value || a[i].breakdown.isSelected !== b[i].breakdown.isSelected) {
            return false;
        }
        if (a[i].filter.length !== b[i].filter.length) {
            return false;
        }
        for (var j = 0; j < a[i].filter.length; j++) {
            if (a[i].filter[j].value !== b[i].filter[j].value || a[i].filter[j].isSelected !== b[i].filter[j].isSelected) {
                return false;
            }
        }
    }
    return true;
};
exports["default"] = dimensionArrayEquals;
